/* The liquid-glass surface every floating control is built from.

   It sits in the `primitives` cascade layer, ordered in `styles/global.css`,
   so a caller's own class always wins over it — the bar is absolute, the
   sheet fixed, the modal carries a deeper shadow — whichever stylesheet the
   browser happened to parse last. Nothing below may rely on coming before or
   after a component module. */

@layer primitives {
  .glass {
    position: relative;
    background: var(--glass);
    -webkit-backdrop-filter: var(--blur);
    backdrop-filter: var(--blur);
    border: 0.5px solid var(--glass-edge);
    box-shadow:
      var(--shadow-2),
      inset 0 1px 0 rgba(255, 255, 255, 0.85),
      inset 0 -1px 0 rgba(47, 191, 113, 0.07);
    isolation: isolate;
  }

  /* Specular sheen along the top edge. */
  .glass::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;
    pointer-events: none;
    background: linear-gradient(
      178deg,
      rgba(255, 255, 255, 0.62) 0%,
      rgba(255, 255, 255, 0.1) 26%,
      rgba(255, 255, 255, 0) 52%
    );
    mix-blend-mode: screen;
  }

  /* Inner green refraction edge. */
  .glass::after {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;
    pointer-events: none;
    box-shadow:
      inset 0 0 0 0.5px var(--glass-edge-2),
      inset 0 0 24px rgba(47, 191, 113, 0.05);
  }

  @supports not ((backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px))) {
    .glass {
      background: rgba(244, 252, 248, 0.93);
    }
  }

  .round {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    display: grid;
    place-items: center;
    color: var(--ink);
    transition:
      transform 0.28s var(--ease),
      background 0.2s,
      box-shadow 0.25s;
  }

  .round:active {
    transform: scale(0.9);
  }

  @media (hover: hover) {
    .round:hover {
      background: var(--glass-strong);
      box-shadow:
        var(--shadow-2),
        0 0 0 4px var(--accent-soft);
    }
  }

  .small {
    width: 32px;
    height: 32px;
  }

  .small svg {
    width: 16px;
    height: 16px;
    stroke-width: 2;
  }

  .pill {
    height: 40px;
    padding: 0 15px 0 12px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    gap: 9px;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: -0.01em;
    transition:
      transform 0.28s var(--ease),
      background 0.2s;
  }

  .pill:active {
    transform: scale(0.95);
  }
}
